export default __webpack_public_path__ + "static/media/card2.1e12ac13.jpg";